import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/unidades/isEmpleadoResponsableUnidad.php';

export default function isEmpleadoResponsableUnidad({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}